export class PlanTrabajo {
    idPlanTrabajo: number;
    fechaAutorizacion: Date;
    idEmpleado: Date;
    manoObraPlan: number;
    costoPlan: number;
    utilidad: number;
    observaciones: string;
    status: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/planTrabajo.ts